import React from 'react'
import type {
    TPossibleApiData,
    TPossibleExtensions,
    TPage,
} from './types'

import {
    thumbStorageName,
} from './constants'

// import '../assets/fonts-sign/fonts-sign.css'

let userUUID: null | string = null
export const getUserUUID = () => userUUID
export const setUserUUID = (uuid: string) => userUUID = uuid
export const refreshUserUUID = (data: TPossibleApiData) => {
    const uuid = data.user_uuid

    if (uuid && uuid !== getUserUUID()) {
        setUserUUID(uuid)
    }
}

export const getMimeFromExt = (ext: TPossibleExtensions) => {
    switch (ext) {
        case 'pdf':
            return 'application/pdf'
        case 'png':
            return 'image/png'
        case 'gif':
            return 'image/gif'
        case 'tif':
        case 'tiff':
            return 'image/tiff'
        case 'jpg':
        case 'jpeg':
            return 'image/jpeg'
        case 'doc':
            return 'application/msword'
        case 'docx':
            return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        case 'xls':
            return 'application/vnd.ms-excel'
        case 'xlsx':
            return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        case 'ppt':
            return 'application/vnd.ms-powerpoint'
        case 'pptx':
            return 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
    
        default:
            return null
    }
}

export const saveThumb = (pages: TPage[]) => {
    const json = JSON.stringify(pages)
    return sessionStorage.setItem(thumbStorageName, json)
}
export const loadThumb = () => {
    let json = sessionStorage.getItem(thumbStorageName)
    if (json) return JSON.parse(json)
    return null
}

export const getColorPickerArray = () => {
    return [
        { color: '#404748', border: '#cbcdcd' },
        { color: '#8FCA27', border: '#e1f1c4' },
        { color: '#2388FE', border: '#C4E9F0' },
        { color: '#FC1B1B', border: '#fec1c1' },
    ]
}
export const getFontPickerArray = () => {
    return [
        'AguafinaScript',
        'AlexBrush',
        'Allura',
        'Cookie',
        'MrDafoe',
        'Pecita',
        'Satisfy',
    ]
}

export const getPngB64 = (base64: string, width: number, height: number) => {
    return new Promise<string>((resolve, reject) => {
        try {
            const canvas = document.createElement('canvas')
            canvas.width = Math.ceil(width)
            canvas.height = Math.ceil(height)
            const ctx = canvas.getContext('2d')
            const img = new Image()
            img.onload = () => {
                if (ctx) {
                    ctx.drawImage(img, 0, 0, canvas.width, canvas.height)
                    resolve(canvas.toDataURL())
                }
                else reject(null)
            }
            img.src = base64
        } catch (e) {
            reject(null)
        }
    })
}

export const textSign = (
    text: string,
    fontID: number,
    colorID: number,
) => {
    const getFontSize = (
        canvas: any,
        ctx: any,
        text: string,
        font: string,
        position: {
            x: number,
            y: number,
        } = { x: 0, y: 0 },
    ) => {
        let maxFontSize = canvas.height / 2.5
        do {
            maxFontSize = maxFontSize - 1
            ctx.font = `${maxFontSize}px ${font}`
        }
        while (ctx.measureText(text).width > canvas.width - position.x)
        return maxFontSize
    }

    const font = getFontPickerArray()[fontID]
    const color = getColorPickerArray()[colorID].color
    let height = 500
    let width = Math.max(height * 2, text.length * height / 5)
    const canvas = document.createElement('canvas')

    if (width > 3000) {
        height = 3000 / width * height
        width = 3000
    }

    canvas.setAttribute('width', `${width}`)
    canvas.setAttribute('height', `${height}`)
    canvas.style.position = 'absolute'
    const ctx = canvas.getContext('2d')
    if (!ctx) return null

    ctx.clearRect(0, 0, canvas.width, canvas.height)
    ctx.textBaseline = 'hanging'
    ctx.textAlign = 'left'
    ctx.fillStyle = color
    const fontSize = getFontSize(canvas, ctx, text, font, { x: 0, y: 0 })
    ctx.font = `${fontSize}px ${font}`

    ctx.fillText(text, (canvas.width - ctx.measureText(text).width) / 2, (canvas.height - fontSize) / 2)
    return canvas.toDataURL()
}

export const getNumber = (string: string) => Number(string.match(/[\d]+\.{0,1}[\d]+/m))